import getEnv from "helpers/get_env";

declare global {
  const DIRECT_STAGING_CALL: boolean;
}

export type Environment = "production" | "staging" | "development";

export const ENV: Environment = getEnv();

export const LOGIN_ROUTE = "/auth/auth0";
export const SALESFORCE_DOMAIN = "https://na105.salesforce.com/";
export const SUPPORT_PHONE = "(855) 664-3887";
export const SUPPORT_CHAT_URL = "u-series-support.lightspeedhq.com";
export const CAPITAL_SUPPORT_EMAIL = "capital@lightspeedhq.com";
const GOODDATA_AUTH0_DEV_SAMLP = "sswJroUf9lRiBZZIa7VZyNUIVm21RQbP3";
const GOODDATA_AUTH0_PROD_SAMLP = "DpedHjoUVWt8TkfyWEF3QqwO35EAk85m";

// Webpack environment variables
declare const PORT_BC: string;
declare const PORT_BC_REPORTS: string;
declare const PORT_SWIPELY: string;

// Default development URLS (mostly point to staging)
const BC_DEV_BASE_URL = "https://pos-hq.staging.upserve.com";
const BC_REPORTS_DEV_BASE_URL = "https://reports-hq.staging.upserve.com";
const SWIPELY_DEV_BASE_URL = "https://app.staging.upserve.com";

interface IAppConstants {
  APP_UPSERVE: string;
  AUTH0_ORIGIN: string;
  AUTH0_UPSERVE_ORIGIN: string;
  BC_API_V1: string;
  BC_AUTH0_LOGIN: string;
  BC_BASE: string;
  BC_HQ: string;
  BC_REPORTS: string;
  CLOUDINARY_BASE_API_URL: string;
  GOODDATA_AUTH0_SAMLP: string;
  GOODDATA_EMBEDDED_REDIRECT: string;
  GTM_CONTAINER_ID: string;
  HQ_SERVICE: string;
  HQ_UI_URL: string;
  INTERCOM_APP_ID: string;
  INVENTORY_AUTH0_LOGIN: string;
  INVENTORY: string;
  LAUNCH_DARKLY_CLIENT_ID: string;
  PARTNERS: string;
  SALESFORCE_DEPLOYMENT_ID: string;
  SALESFORCE_BUTTON_ID: string;
  SALESFORCE_ESW_LIVE_AGENT_DEV_NAME: string;
  SALESFORCE_CHAT_BASE_URL: string;
  SALESFORCE_CHAT_CHAT_API: string;
  SALESFORCE_CHAT_CONTENT_API: string;
  SALESFORCE_CHAT_EMBED_URL: string;
  SALESFORCE_CHAT_HELP_URL: string;
  SALESFORCE_CHAT_ORG_ID: string;
  SEGMENT_KEY: string;
  WORKFORCE: string;
  X_UPSERVE_AUTH_TOKEN: string;
  NEURAFLASH_CHATBOT_SRC: string;
  NEURAFLASH_CHATBOT_PARAMS: string;
}

const CONFIG: Record<Environment, IAppConstants> = {
  development: {
    APP_UPSERVE: SWIPELY_DEV_BASE_URL,
    AUTH0_ORIGIN: "https://upserve.auth0.com",
    AUTH0_UPSERVE_ORIGIN: "https://login.upserve.com",
    BC_API_V1: `${BC_DEV_BASE_URL}/api/v1`,
    BC_AUTH0_LOGIN: `${BC_DEV_BASE_URL}/users/auth/auth0`,
    BC_BASE: `${BC_DEV_BASE_URL}`,
    BC_HQ: `${BC_DEV_BASE_URL}/hq/restaurants`,
    BC_REPORTS: `${BC_REPORTS_DEV_BASE_URL}/hq/restaurants`,
    CLOUDINARY_BASE_API_URL: "https://api.cloudinary.com/v1_1/upserve",
    GOODDATA_AUTH0_SAMLP: GOODDATA_AUTH0_DEV_SAMLP,
    GOODDATA_EMBEDDED_REDIRECT:
      "https://upserve.na.gooddata.com/analyze/embedded/",
    GTM_CONTAINER_ID: "GTM-KSHS4F6",
    HQ_SERVICE: !DIRECT_STAGING_CALL
      ? "http://localhost:3000"
      : "https://hq-api.staging.upserve.com",
    HQ_UI_URL: "http://localhost:8080",
    INTERCOM_APP_ID: "keg7twgr",
    INVENTORY: "https://inventory.upserve.com",
    INVENTORY_AUTH0_LOGIN: "https://inventory.upserve.com/auth0/login",
    LAUNCH_DARKLY_CLIENT_ID: "56932174559981069b000013",
    PARTNERS: `${SWIPELY_DEV_BASE_URL}/partners`,
    SALESFORCE_DEPLOYMENT_ID: "572C0000000XZMe",
    SALESFORCE_BUTTON_ID: "573C0000000XZRf",
    SALESFORCE_ESW_LIVE_AGENT_DEV_NAME:
      "EmbeddedServiceLiveAgent_Parent04IC0000000XZAbMAO_15d7aff7905",
    SALESFORCE_CHAT_BASE_URL: "https://upservepos.my.salesforce.com",
    SALESFORCE_CHAT_CHAT_API:
      "https://d.la3-c2-ia2.salesforceliveagent.com/chat",
    SALESFORCE_CHAT_CONTENT_API:
      "https://c.la3-c2-ia2.salesforceliveagent.com/content",
    SALESFORCE_CHAT_EMBED_URL:
      "https://upservepos.my.salesforce.com/embeddedservice/5.0/esw.min.js",
    SALESFORCE_CHAT_HELP_URL: "https://u-series-support.lightspeedhq.com/",
    SALESFORCE_CHAT_ORG_ID: "00DC0000000Pzj5",
    SEGMENT_KEY: "",
    WORKFORCE: "https://workforce.upserve.com",
    X_UPSERVE_AUTH_TOKEN: "X-Upserve-Auth-Token-Development",
    NEURAFLASH_CHATBOT_SRC:
      "https://neuraflash-swipelycommunity.cs62.force.com/upservechatbotdraft/lightning/lightning.out.js",
    NEURAFLASH_CHATBOT_PARAMS:
      "https://neuraflash-swipelycommunity.cs62.force.com/upservechatbotdraft",
  },
  staging: {
    APP_UPSERVE: "https://app.staging.upserve.com",
    AUTH0_ORIGIN: "https://upserve-staging.auth0.com",
    AUTH0_UPSERVE_ORIGIN: "https://login.staging.upserve.com",
    BC_API_V1: "https://pos-hq.staging.upserve.com/api/v1",
    BC_AUTH0_LOGIN: "https://pos-hq.staging.upserve.com/users/auth/auth0",
    BC_BASE: "https://pos-hq.staging.upserve.com",
    BC_HQ: "https://pos-hq.staging.upserve.com/hq/restaurants",
    BC_REPORTS: "https://reports-hq.staging.upserve.com/hq/restaurants",
    CLOUDINARY_BASE_API_URL: "https://api.cloudinary.com/v1_1/upserve",
    GOODDATA_AUTH0_SAMLP: GOODDATA_AUTH0_DEV_SAMLP,
    GOODDATA_EMBEDDED_REDIRECT:
      "https://upserve.na.gooddata.com/analyze/embedded/",
    GTM_CONTAINER_ID: "GTM-KSHS4F6",
    HQ_SERVICE: "https://hq-api.staging.upserve.com",
    HQ_UI_URL: "https://hq.staging.upserve.com",
    INTERCOM_APP_ID: "keg7twgr",
    INVENTORY: "https://inventory.staging.upserve.com",
    INVENTORY_AUTH0_LOGIN: "https://inventory.staging.upserve.com/auth0/login",
    LAUNCH_DARKLY_CLIENT_ID: "56b3645f581f3c06d8000004",
    PARTNERS: "https://app.staging.upserve.com/partners",
    SALESFORCE_DEPLOYMENT_ID: "572C0000000XZMe",
    SALESFORCE_BUTTON_ID: "573C0000000XZRf",
    SALESFORCE_ESW_LIVE_AGENT_DEV_NAME:
      "EmbeddedServiceLiveAgent_Parent04IC0000000XZAbMAO_15d7aff7905",
    SALESFORCE_CHAT_BASE_URL: "https://service.force.com",
    SALESFORCE_CHAT_CHAT_API:
      "https://d.la3-c2-ia2.salesforceliveagent.com/chat",
    SALESFORCE_CHAT_CONTENT_API:
      "https://c.la3-c2-ia2.salesforceliveagent.com/content",
    SALESFORCE_CHAT_EMBED_URL:
      "https://upservepos.my.salesforce.com/embeddedservice/5.0/esw.min.js",
    SALESFORCE_CHAT_HELP_URL: "https://u-series-support.lightspeedhq.com/",
    SALESFORCE_CHAT_ORG_ID: "00DC0000000Pzj5",
    SEGMENT_KEY: "Q5uCGRG1TtSHTwImrG7nPgItkwGBDQpC",
    WORKFORCE: "https://workforce.staging.upserve.com",
    X_UPSERVE_AUTH_TOKEN: "X-Upserve-Auth-Token-Staging",
    NEURAFLASH_CHATBOT_SRC:
      "https://neuraflash-swipelycommunity.cs62.force.com/upservechatbotdraft/lightning/lightning.out.js",
    NEURAFLASH_CHATBOT_PARAMS:
      "https://neuraflash-swipelycommunity.cs62.force.com/upservechatbotdraft",
  },
  production: {
    APP_UPSERVE: "https://app.upserve.com",
    AUTH0_ORIGIN: "https://upserve.auth0.com",
    AUTH0_UPSERVE_ORIGIN: "https://login.upserve.com",
    BC_API_V1: "https://pos-hq.upserve.com/api/v1",
    BC_AUTH0_LOGIN: "https://pos-hq.upserve.com/users/auth/auth0",
    BC_BASE: "https://pos-hq.upserve.com",
    BC_HQ: "https://pos-hq.upserve.com/hq/restaurants",
    BC_REPORTS: "https://reports-hq.upserve.com/hq/restaurants",
    CLOUDINARY_BASE_API_URL: "https://api.cloudinary.com/v1_1/upserve",
    GOODDATA_AUTH0_SAMLP: GOODDATA_AUTH0_PROD_SAMLP,
    GOODDATA_EMBEDDED_REDIRECT:
      "https://upserve.na.gooddata.com/analyze/embedded/",
    GTM_CONTAINER_ID: "GTM-KSGD8W3",
    HQ_SERVICE: "https://hq-api.upserve.com",
    HQ_UI_URL: "https://hq.upserve.com",
    INTERCOM_APP_ID: "ck7yekya",
    INVENTORY: "https://inventory.upserve.com",
    INVENTORY_AUTH0_LOGIN: "https://inventory.upserve.com/auth0/login",
    LAUNCH_DARKLY_CLIENT_ID: "56932174559981069b000014",
    PARTNERS: "https://app.upserve.com/partners",
    SALESFORCE_DEPLOYMENT_ID: "572C0000000XZMe",
    SALESFORCE_BUTTON_ID: "573C0000000XZRf",
    SALESFORCE_ESW_LIVE_AGENT_DEV_NAME:
      "EmbeddedServiceLiveAgent_Parent04IC0000000XZAbMAO_15d7aff7905",
    SALESFORCE_CHAT_BASE_URL: "https://service.force.com",
    SALESFORCE_CHAT_CHAT_API:
      "https://d.la3-c2-ia2.salesforceliveagent.com/chat",
    SALESFORCE_CHAT_CONTENT_API:
      "https://c.la3-c2-ia2.salesforceliveagent.com/content",
    SALESFORCE_CHAT_EMBED_URL:
      "https://upservepos.my.salesforce.com/embeddedservice/5.0/esw.min.js",
    SALESFORCE_CHAT_HELP_URL: "https://u-series-support.lightspeedhq.com/",
    SALESFORCE_CHAT_ORG_ID: "00DC0000000Pzj5",
    SEGMENT_KEY: "I8xFTTBUKUCup8yjEZOUidgQxPtMf4Xq",
    WORKFORCE: "https://workforce.upserve.com",
    X_UPSERVE_AUTH_TOKEN: "X-Upserve-Auth-Token",
    NEURAFLASH_CHATBOT_SRC:
      "https://swipelycommunity.force.com/chatbotdeploy/lightning/lightning.out.js",
    NEURAFLASH_CHATBOT_PARAMS:
      "https://swipelycommunity.force.com/chatbotdeploy",
  },
};

export const getConfig = (env: Environment) => {
  return CONFIG[env];
};

export const {
  APP_UPSERVE,
  AUTH0_ORIGIN,
  AUTH0_UPSERVE_ORIGIN,
  BC_API_V1,
  BC_AUTH0_LOGIN,
  BC_BASE,
  BC_HQ,
  BC_REPORTS,
  CLOUDINARY_BASE_API_URL,
  GOODDATA_AUTH0_SAMLP,
  GOODDATA_EMBEDDED_REDIRECT,
  GTM_CONTAINER_ID,
  HQ_SERVICE,
  INTERCOM_APP_ID,
  INVENTORY,
  INVENTORY_AUTH0_LOGIN,
  LAUNCH_DARKLY_CLIENT_ID,
  PARTNERS,
  SALESFORCE_DEPLOYMENT_ID,
  SALESFORCE_BUTTON_ID,
  SALESFORCE_ESW_LIVE_AGENT_DEV_NAME,
  SALESFORCE_CHAT_BASE_URL,
  SALESFORCE_CHAT_CHAT_API,
  SALESFORCE_CHAT_CONTENT_API,
  SALESFORCE_CHAT_EMBED_URL,
  SALESFORCE_CHAT_HELP_URL,
  SALESFORCE_CHAT_ORG_ID,
  NEURAFLASH_CHATBOT_PARAMS,
  NEURAFLASH_CHATBOT_SRC,
  SEGMENT_KEY,
  WORKFORCE,
  X_UPSERVE_AUTH_TOKEN,
} = getConfig(ENV);
